/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PresenterPhotoInformation, PresenterResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Photos<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Upload photo
   *
   * @tags photos
   * @name PostPhotosUpload
   * @summary Upload the photo
   * @request POST:/photos/upload
   */
  postPhotosUpload = (
    data: {
      /** photo file */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterPhotoInformation;
      },
      any
    >({
      path: `/photos/upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}
